module.exports = __webpack_public_path__ + "img/welcome-step-3.202787d9.png";